module.exports = __webpack_public_path__ + "static/media/crowdFundingText.cc1478cc.svg";